import { BaseRecord } from 'app/context/data/types';
import { Descriptions } from 'app/modules/ui';
import React from 'react';
import { DESCRIPTION_DEF } from './config';
import { InspectionPOItem } from 'app/modules/inspection/types';
import classes from './OnSiteChecking.module.scss';

type OnSiteCheckingProps<T = BaseRecord> = {
  value: T;
  progress?: string;
  poItem: InspectionPOItem;
};

export const OnSiteChecking = (props: OnSiteCheckingProps) => {
  const { value, progress, poItem } = props;
  const descriptionValue = React.useMemo(() => {
    return {
      ...value,
      progress
    };
  }, [value, progress]);

  return (
    <Descriptions
      className={classes.collapse}
      column={1}
      items={DESCRIPTION_DEF}
      value={descriptionValue}
      meta={{ poItem }}
    />
  );
};
